/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DeleteCard200Response } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetCards200Response } from '../models';
// @ts-ignore
import type { RegisterCard200Response } from '../models';
// @ts-ignore
import type { RegisterCardRequest } from '../models';
/**
 * PaymentMethodsApi - axios parameter creator
 * @export
 */
export const PaymentMethodsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 등록된 카드를 삭제합니다. 삭제된 카드는 더 이상 결제에 사용할 수 없습니다. 
         * @summary 카드 삭제
         * @param {string} cardId 삭제할 카드 ID (빌링키)
         * @param {string} [userId] 사용자 ID (관리자용)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCard: async (cardId: string, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('deleteCard', 'cardId', cardId)
            const localVarPath = `/api/v1/payment-methods/cards/{cardId}`
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 사용자가 등록한 카드 목록을 조회합니다. 등록된 모든 카드의 정보를 반환합니다. 
         * @summary 카드 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCards: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment-methods/cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 결제용 카드를 등록합니다. 등록된 카드는 구독 결제에 사용됩니다. 
         * @summary 카드 등록
         * @param {RegisterCardRequest} registerCardRequest 카드 등록 정보
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerCard: async (registerCardRequest: RegisterCardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerCardRequest' is not null or undefined
            assertParamExists('registerCard', 'registerCardRequest', registerCardRequest)
            const localVarPath = `/api/v1/payment-methods/cards/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerCardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentMethodsApi - functional programming interface
 * @export
 */
export const PaymentMethodsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentMethodsApiAxiosParamCreator(configuration)
    return {
        /**
         * 등록된 카드를 삭제합니다. 삭제된 카드는 더 이상 결제에 사용할 수 없습니다. 
         * @summary 카드 삭제
         * @param {string} cardId 삭제할 카드 ID (빌링키)
         * @param {string} [userId] 사용자 ID (관리자용)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCard(cardId: string, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCard(cardId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.deleteCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 사용자가 등록한 카드 목록을 조회합니다. 등록된 모든 카드의 정보를 반환합니다. 
         * @summary 카드 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCards(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCards200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCards(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.getCards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 결제용 카드를 등록합니다. 등록된 카드는 구독 결제에 사용됩니다. 
         * @summary 카드 등록
         * @param {RegisterCardRequest} registerCardRequest 카드 등록 정보
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerCard(registerCardRequest: RegisterCardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterCard200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerCard(registerCardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentMethodsApi.registerCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentMethodsApi - factory interface
 * @export
 */
export const PaymentMethodsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentMethodsApiFp(configuration)
    return {
        /**
         * 등록된 카드를 삭제합니다. 삭제된 카드는 더 이상 결제에 사용할 수 없습니다. 
         * @summary 카드 삭제
         * @param {PaymentMethodsApiDeleteCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCard(requestParameters: PaymentMethodsApiDeleteCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteCard200Response> {
            return localVarFp.deleteCard(requestParameters.cardId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 사용자가 등록한 카드 목록을 조회합니다. 등록된 모든 카드의 정보를 반환합니다. 
         * @summary 카드 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCards(options?: RawAxiosRequestConfig): AxiosPromise<GetCards200Response> {
            return localVarFp.getCards(options).then((request) => request(axios, basePath));
        },
        /**
         * 결제용 카드를 등록합니다. 등록된 카드는 구독 결제에 사용됩니다. 
         * @summary 카드 등록
         * @param {PaymentMethodsApiRegisterCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerCard(requestParameters: PaymentMethodsApiRegisterCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegisterCard200Response> {
            return localVarFp.registerCard(requestParameters.registerCardRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentMethodsApi - interface
 * @export
 * @interface PaymentMethodsApi
 */
export interface PaymentMethodsApiInterface {
    /**
     * 등록된 카드를 삭제합니다. 삭제된 카드는 더 이상 결제에 사용할 수 없습니다. 
     * @summary 카드 삭제
     * @param {PaymentMethodsApiDeleteCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApiInterface
     */
    deleteCard(requestParameters: PaymentMethodsApiDeleteCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteCard200Response>;

    /**
     * 사용자가 등록한 카드 목록을 조회합니다. 등록된 모든 카드의 정보를 반환합니다. 
     * @summary 카드 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApiInterface
     */
    getCards(options?: RawAxiosRequestConfig): AxiosPromise<GetCards200Response>;

    /**
     * 결제용 카드를 등록합니다. 등록된 카드는 구독 결제에 사용됩니다. 
     * @summary 카드 등록
     * @param {PaymentMethodsApiRegisterCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApiInterface
     */
    registerCard(requestParameters: PaymentMethodsApiRegisterCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegisterCard200Response>;

}

/**
 * Request parameters for deleteCard operation in PaymentMethodsApi.
 * @export
 * @interface PaymentMethodsApiDeleteCardRequest
 */
export interface PaymentMethodsApiDeleteCardRequest {
    /**
     * 삭제할 카드 ID (빌링키)
     * @type {string}
     * @memberof PaymentMethodsApiDeleteCard
     */
    readonly cardId: string

    /**
     * 사용자 ID (관리자용)
     * @type {string}
     * @memberof PaymentMethodsApiDeleteCard
     */
    readonly userId?: string
}

/**
 * Request parameters for registerCard operation in PaymentMethodsApi.
 * @export
 * @interface PaymentMethodsApiRegisterCardRequest
 */
export interface PaymentMethodsApiRegisterCardRequest {
    /**
     * 카드 등록 정보
     * @type {RegisterCardRequest}
     * @memberof PaymentMethodsApiRegisterCard
     */
    readonly registerCardRequest: RegisterCardRequest
}

/**
 * PaymentMethodsApi - object-oriented interface
 * @export
 * @class PaymentMethodsApi
 * @extends {BaseAPI}
 */
export class PaymentMethodsApi extends BaseAPI implements PaymentMethodsApiInterface {
    /**
     * 등록된 카드를 삭제합니다. 삭제된 카드는 더 이상 결제에 사용할 수 없습니다. 
     * @summary 카드 삭제
     * @param {PaymentMethodsApiDeleteCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public deleteCard(requestParameters: PaymentMethodsApiDeleteCardRequest, options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).deleteCard(requestParameters.cardId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 사용자가 등록한 카드 목록을 조회합니다. 등록된 모든 카드의 정보를 반환합니다. 
     * @summary 카드 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public getCards(options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).getCards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 결제용 카드를 등록합니다. 등록된 카드는 구독 결제에 사용됩니다. 
     * @summary 카드 등록
     * @param {PaymentMethodsApiRegisterCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodsApi
     */
    public registerCard(requestParameters: PaymentMethodsApiRegisterCardRequest, options?: RawAxiosRequestConfig) {
        return PaymentMethodsApiFp(this.configuration).registerCard(requestParameters.registerCardRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

